import React, { useEffect, useMemo, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
// import { ImBlog } from "react-icons/im";
import { FiChevronDown } from "react-icons/fi";

// import { CgFileDocument } from "react-icons/cg";
import './Navbar.css';

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const navigate = useNavigate(); // Create the navigate function
  const location = useLocation();

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  useEffect(() => {
    scrollHandler();
    window.addEventListener("scroll", scrollHandler, { passive: true });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

   // Function to handle button click for navigation
   const handleButtonClick = () => {
    navigate("/lab");
  };

  const active = useMemo(() => {
    const path = location.pathname;
    return {
      home: path === "/",
      about: path.startsWith("/about"),
      programs: path.startsWith("/programs"),
      services: path.startsWith("/services"),
      team: path.startsWith("/team"),
      contact: path.startsWith("/contact"),
      involved: [
        "/programs/ambassadors",
        "/programs/syep-internship",
        "/programs/code-and-soil",
        "/programs/senior-citizens",
        "/programs/tech-pal",
        "/programs/partner-with-us",
        "/programs/volunteer-opportunities",
      ].some((prefix) => path.startsWith(prefix)),
    };
  }, [location.pathname]);
  
  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={`cf-navbar${navColour ? " cf-navbar--scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="cf-navbar-brand d-flex" aria-label="Choicest Fruit home">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto cf-navbar-nav" aria-label="Primary">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} active={active.home}>
                Home
              </Nav.Link>
            </Nav.Item>

            {/* About Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  About <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="about-nav-dropdown"
              menuVariant="light"
              active={active.about}
            >
              <NavDropdown.Item as={Link} to="/about/who-we-are" onClick={() => updateExpanded(false)}>
                Who We Are
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-mission" onClick={() => updateExpanded(false)}>
                Our Mission
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-story" onClick={() => updateExpanded(false)}>
                Our Story
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/impact" onClick={() => updateExpanded(false)}>
                Impact
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-partners" onClick={() => updateExpanded(false)}>
                Our Partners
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/testimonials" onClick={() => updateExpanded(false)}>
                Testimonials
              </NavDropdown.Item>
            </NavDropdown>
            {/* End About Dropdown */}



            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  Programs <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="programs-nav-dropdown"
              menuVariant="light"
              active={active.programs}
            >  
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              Career Training Programs
              </NavDropdown.Item>                       
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              Community Programs
              </NavDropdown.Item>               
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              Workshops & Exploratory Learning
              </NavDropdown.Item>
           
            </NavDropdown>

            {/* Services Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  Services <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="services-nav-dropdown"
              menuVariant="light"
              active={active.services}
            >
              <NavDropdown.Item as={Link} to="/services/favrhood" onClick={() => updateExpanded(false)}>
                Favrhood
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/consulting-advisory" onClick={() => updateExpanded(false)}>
                Consulting & Advisory
              </NavDropdown.Item>                                      
            </NavDropdown>
            {/* End Services Dropdown */}

              <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  Get Involved <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="get-involved-nav-dropdown"
              menuVariant="light"
              active={active.involved}
            >
              <NavDropdown.Item as={Link} to="/programs/ambassadors" onClick={() => updateExpanded(false)}>
                Ambassadors
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/syep-internship" onClick={() => updateExpanded(false)}>
                Internship
              </NavDropdown.Item>  
              <NavDropdown.Item as={Link} to="/programs/code-and-soil" onClick={() => updateExpanded(false)}>
                Code and Soil
              </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/programs/senior-citizens" onClick={() => updateExpanded(false)}>
                Senior Tech
              </NavDropdown.Item>
                 <NavDropdown.Item as={Link} to="/programs/tech-pal" onClick={() => updateExpanded(false)}>
                Tech Pal
              </NavDropdown.Item>   
              <NavDropdown.Item as={Link} to="/programs/partner-with-us" onClick={() => updateExpanded(false)}>
                Partner With Us
              </NavDropdown.Item>                   
              <NavDropdown.Item as={Link} to="/programs/volunteer-opportunities" onClick={() => updateExpanded(false)}>
                Volunteer Opportunities
              </NavDropdown.Item>
            
            </NavDropdown>


            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/team"
                onClick={() => updateExpanded(false)}
                active={active.team}
              >
               
                Team
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => updateExpanded(false)}
                active={active.contact}
              >
                 Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://choicestfruit.com/blog/"
                target="_blank"
                rel="noreferrer"
              >
                 Blogs
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="fork-btn cf-navbar-cta">
              <Button
                onClick={handleButtonClick} // Use the navigate function here
                className="fork-btn-inner"
                type="button"
              >
                CF Lab
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
